module.exports = __webpack_public_path__ + "img/bg1.20166e03.png";